// WebViews com storage bloqueado lançam já no acesso à propriedade `localStorage`.
export const getLocalStorage = (key: string) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : undefined;
  } catch {
    return undefined;
  }
};

export const setLocalStorage = (key: string, value: unknown) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // storage bloqueado: segue sem persistir
  }
};

export const removeLocalStorage = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch {
    // storage bloqueado: nada a remover
  }
};

export const clearLocalStorage = () => {
  try {
    localStorage.clear();
  } catch {
    // storage bloqueado: nada a limpar
  }
};
